import React from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { TrendingUp, Business, AccountBalance, Receipt } from "@mui/icons-material";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";

const services = [
  { id: "01", title: "Financial Planning", icon: <TrendingUp fontSize="large" color={COLORS.secondaryColor} />, description: "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected." },
  { id: "02", title: "Investment Advisory", icon: <Business fontSize="large" color={COLORS.secondaryColor}/>, description: "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected." },
  { id: "03", title: "Tax Planning", icon: <Receipt fontSize="large"  color={COLORS.secondaryColor}/>, description: "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected." },
  { id: "04", title: "Corporate Finance", icon: <AccountBalance fontSize="large" color={COLORS.secondaryColor} />, description: "There are many variations of passages of Lorem the Ipsum available, but the majority have suffered of alteration in some form, by injected." }
];

const FinancialServices = ({isMobile}) => {
  return (
    <Box sx={{ p: 4,marginLeft:isMobile?0:7 }}>
      <Typography variant="h6" color={COLORS.secondaryColor} fontFamily={fontFamilyAll}>Our Services</Typography>
      <Typography variant={isMobile?"h5":"h3"} fontWeight="bold" gutterBottom fontFamily={fontFamilyAll}>
        Comprehensive Financial Planning and Analysis
      </Typography>
      <Grid container spacing={3}>
        {services.map((service) => (
          <Grid item xs={12} sm={6} key={service.id}>
            <Card sx={{ display: "flex", alignItems: "center", p: 2, borderRadius: 2, boxShadow: 3 }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  {service.icon}
                  <Typography variant="h6" fontWeight="bold" fontFamily={fontFamilyAll}>{service.title}</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary" mt={1} fontFamily={fontFamilyAll}>{service.description}</Typography>
              </CardContent>
              <Typography variant="h2" fontWeight="bold" color="black" sx={{ opacity: 0.2, pr: 2 }} fontFamily={fontFamilyAll}>
                {service.id}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FinancialServices;